import React from "react";
import { Link } from "react-router-dom";

export default function InstitutionHeroSection({ data }) {
  const extraClassName = data.className || "";

  return (
    <section
      className={`institution-hero ${extraClassName}`.trim()}
      style={{ backgroundImage: `url(${data.backgroundImage})` }}
    >
      <div className="institution-hero-overlay" />
      <div className="container institution-hero-content">
        <div className="row">
          <div className="col-lg-7">
            <nav className="institution-breadcrumbs" aria-label="Breadcrumb">
          {data.breadcrumbs.map((item, index) => (
            <React.Fragment key={item.label}>
              {item.to ? <Link to={item.to}>{item.label}</Link> : <span>{item.label}</span>}
              {index < data.breadcrumbs.length - 1 && <span aria-hidden="true">|</span>}
            </React.Fragment>
          ))}
        </nav>
        <h1 className="heading text-white text-capitalize">{data.title}</h1>
        <p>{data.description}</p>
          </div>
        </div>
      </div>
    </section>
  );
}
